import { render, staticRenderFns } from "./VideoCard.vue?vue&type=template&id=12cfa6fc&scoped=true&"
import script from "./VideoCard.vue?vue&type=script&lang=js&"
export * from "./VideoCard.vue?vue&type=script&lang=js&"
import style0 from "./VideoCard.vue?vue&type=style&index=0&id=12cfa6fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12cfa6fc",
  null
  
)

export default component.exports